var Handlebars = require("/Users/niall/projects/workflows-js/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<p>\nAn operation node represents a function that processes a set of inputs and results in a set of outputs. </p>\n<p>It has a category (which can be selected from the Operation branch of the EDAM ontology); a textual description; and associated tools, training and other relevant resources to help readers understand the what, why, and how of the operation.\n</p>\n\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/edit_docs/snippets/operation.hbs
// module id = 149
// module chunks = 0